import { useRepositoryQuery } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { useGetSettlementRuleName } from '../../../../../components';

export const useCentralPaymentPolicyOptions = () => {
    const getSettlementRuleName = useGetSettlementRuleName();

    const { data: paymentPolicyOptions, isFetching: isFetchingPaymentPolicies } = useRepositoryQuery(
        'portfolioCentralPaymentPolicies',
        'getAll',
        {},
        {
            select: (data) =>
                data?.centralPaymentPolicies?.map((settlementRule) => {
                    const constructedName = getSettlementRuleName(
                        {
                            ...settlementRule,
                            value: {
                                discriminator: 'Percentage',
                                // @ts-expect-error Type 'undefined' is not assignable to type 'number'
                                value: { value: settlementRule.percentageValue },
                            },
                        },
                        { format: 'parameters' }
                    );
                    return createOption({
                        value: settlementRule.id,
                        label: settlementRule.name || constructedName,
                        secondaryText: settlementRule.name ? constructedName : null,
                    });
                }),
        }
    );

    return { data: paymentPolicyOptions ?? [], isFetching: isFetchingPaymentPolicies };
};
